import React from "react";
import Styles from "./Loder.module.css";

const BlockEverything = () => {
  return (
    <div className={Styles.loaderContainer2}>
      <div className={Styles.loader}></div>
    </div>
  );
};

export default BlockEverything;
